import Vue from "vue";
import "./service/compatible";
import App from "./App.vue";
import router from "./router";
import getApi from "./service/index";
import { store } from "./store";
import "./assets/css/reset.css";
import "./assets/css/common.styl";
import "./assets/js/common.js";
import "./assets/js/statistics";
import "./assets/js/filter.js";
import "@babel/polyfill";
import TableEx from "./components/tablePackage";
import echarts from "echarts/lib/echarts";
import oecharts from "echarts";
import inputSelect from "./components/common/InputSelect.vue";
import exportExcelBtn from './components/common/ExportExcelBtn.vue'
import VueSuperSlide from "vue-superslide";
import "./common/filter";
import Alert from "./components/alert/alert.js";
import utils from "@/utils/utils";
import print from "vue-print-nb";
import md5 from "js-md5";
import UmyUi from "umy-ui";
import "umy-ui/lib/theme-chalk/index.css"; // 引入样式
Vue.use(UmyUi);
let bus = new Vue();
Vue.prototype.bus = bus;
Vue.prototype.$Alert = Alert;
import {
  Pagination,
  Dialog,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Input,
  RadioGroup,
  RadioButton,
  Select,
  Option,
  Button,
  Table,
  TableColumn,
  DatePicker,
  TimePicker,
  Tooltip,
  Form,
  FormItem,
  Icon,
  Row,
  Col,
  Container,
  Header,
  Aside,
  Main,
  Footer,
  Loading,
  MessageBox,
  Message,
  Upload,
  Radio,
  Tabs,
  TabPane,
  Switch,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Tree,
  Scrollbar,
  Popover,
  Slider,
  Image,
} from "element-ui";

Vue.use(Pagination);
Vue.use(Image);
Vue.use(Dialog);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Input);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Select);
Vue.use(Option);
Vue.use(Button);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(DatePicker);
Vue.use(TimePicker);
Vue.use(Tooltip);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Icon);
Vue.use(Row);
Vue.use(Col);
Vue.use(Container);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Footer);
Vue.use(Upload);
Vue.use(Loading.directive);
Vue.use(Radio);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Switch);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Tree);
Vue.use(Scrollbar);
Vue.use(Popover);
Vue.use(Slider);
Vue.component(MessageBox.name, MessageBox);

Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$message = Message;
Vue.prototype.$echarts = echarts;
Vue.prototype.$oecharts = oecharts;
Vue.use(TableEx);
Vue.use(VueSuperSlide);
Vue.prototype.$api = getApi;
Vue.prototype.$md5 = md5;
Vue.prototype.utils = utils;
Vue.config.productionTip = false;
Vue.use(print);
console.log("当前环境变量：", process.env);
Vue.component("inputSelect", inputSelect);
Vue.component("exportExcelBtn", exportExcelBtn);
// button阻止重复点击
Vue.directive("preventReClick", {
  inserted(el, binding) {
    el.addEventListener("click", () => {
      if (!el.disabled) {
        el.disabled = true;
        setTimeout(() => {
          el.disabled = false;
        }, binding.value || 3000);
      }
    });
  },
});

Vue.directive("focus", {
  inserted(el, { value }) {
    if (value) {
      el.focus();
    }
  },
});

Vue.directive("enterMoney", {
  inserted: function (el) {
    el.addEventListener("keypress", function (e) {
      e = e || window.event;
      const charcode = typeof e.charCode === "number" ? e.charCode : e.keyCode;
      const re = /\d/;
      if (charcode === 46) {
        // el.children[0].value是配合了el-input输入框使用的，使用input输入框时直接用el.value
        // 只能输入一个小数点，超过一个则禁止输入
        if (el.children[0].value.includes(".")) {
          e.preventDefault();
        }
        return;
      } else if (
        !re.test(String.fromCharCode(charcode)) &&
        charcode > 9 &&
        !e.ctrlKey
      ) {
        if (e.preventDefault) {
          e.preventDefault();
        } else {
          e.returnValue = false;
        }
      }
    });
  },
});

Vue.prototype.S4 = function () {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
};
Vue.prototype.guid = function () {
  return (
    this.S4() +
    this.S4() +
    "-" +
    this.S4() +
    "-" +
    this.S4() +
    "-" +
    this.S4() +
    "-" +
    this.S4() +
    this.S4() +
    this.S4()
  );
};

// main.js

Vue.directive("defaultSelect", {
  componentUpdated(el, bindings, vnode) {
    // values v-model 绑定值
    // options 下拉选项
    // prop 对应 options 中 的 value 属性
    // defaultProp 默认值判断属性
    // defaultValue 默认值判断值
    const [values, options, prop, defaultProp, defaultValue] = bindings.value;
    // 需要隐藏的标签索引
    const indexs = [];
    const tempData = values.map((a) => options.find((op) => op[prop] === a));
    tempData.forEach((a, index) => {
      if (a[defaultProp] === defaultValue) indexs.push(index);
    });
    const dealStyle = function (tags) {
      tags.forEach((el, index) => {
        if (
          indexs.includes(index) &&
          ![...el.classList].includes("select-tag-close-none")
        ) {
          el.classList.add("none");
        }
      });
    };
    // 设置样式 隐藏close icon
    const tags = el.querySelectorAll(".el-tag__close");
    if (tags.length === 0) {
      // 初始化tags为空处理
      setTimeout(() => {
        const tagTemp = el.querySelectorAll(".el-tag__close");
        dealStyle(tagTemp);
      });
    } else {
      dealStyle(tags);
    }
  },
});

new Vue({
  router,
  store: store,
  render: (h) => h(App),
}).$mount("#app");
